import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "ga_token";

export const api = axios.create({ baseURL: API });

export const DEVICE_KEY = "ga_device_id";
export function deviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) { id = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)).replace(/-/g, ""); localStorage.setItem(DEVICE_KEY, id); }
  return id;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Device-Id"] = deviceId();
  return config;
});

api.interceptors.response.use((r) => r, (error) => {
  const d = error?.response?.data?.detail;
  if (error?.response?.status === 403 && d && typeof d === "object" && d.code === "email_unverified" && window.location.pathname !== "/verificar-email") {
    window.location.assign("/verificar-email");
  }
  return Promise.reject(error);
});

export const absUrl = (path) => (path?.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path);

export function errorMessage(e, fallback = "Algo deu errado. Tente novamente.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || fallback;
}

export const isPaywallError = (e) => e?.response?.status === 402;
